import React from "react";

const DetailRankingTable = (props) => {
  const {home, away, standing} = props;
  return (
    <div className={'grid grid-cols-1 @lg:grid-cols-2 gap-2 py-4'}>
      <div>
        <div className={'grid gap-1'}>
          <div className={'bg-button-blue-bet text-white-half text-sm text-center p-0.5 rounded-sm'}>{home.name}</div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center bg-header-blue dark:bg-pure-black p-[7px] text-button-blue-bet dark:text-stroke-o3 text-xxxs'}>
            <div className={'w-2/12 text-left'}>FT</div>
            <div className={'w-1/12'}>Trận</div>
            <div className={'w-1/12'}>Thắng</div>
            <div className={'w-1/12'}>Hòa</div>
            <div className={'w-1/12'}>Bại</div>
            <div className={'w-1/12'}>Ghi</div>
            <div className={'w-1/12'}>Mất</div>
            <div className={'w-1/12'}>Điểm</div>
            <div className={'w-2/12'}>Xếp hạng</div>
            <div className={'w-1/12 text-right'}>T%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet dark:bg-dark-slate dark:text-stroke-o3 text-xxxs bg-white'}>
            <div className={'w-2/12 text-left'}>Tổng</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.totalStandings[0]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.totalStandings[0]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.totalStandings[0]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>Sân Nhà</div>
            <div className={'w-1/12'}>{standing?.homeStandings[0]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[0]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[0]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[0]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[0]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[0]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.homeStandings[0]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.homeStandings[0]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.homeStandings[0]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left font-extra-bold'}>Sân Khách</div>
            <div className={'w-1/12'}>{standing?.awayStandings[0]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[0]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[0]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[0]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[0]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[0]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.awayStandings[0]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.awayStandings[0]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.awayStandings[0]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>6 Trận Gần</div>
            <div className={'w-1/12'}>{standing?.halfStandings[0]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[0]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[0]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[0]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[0]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[0]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.halfStandings[0]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.halfStandings[0]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.halfStandings[0]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center bg-header-blue p-[7px] text-button-blue-bet text-xxxs dark:bg-pure-black dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>HT</div>
            <div className={'w-1/12'}>Trận</div>
            <div className={'w-1/12'}>Thắng</div>
            <div className={'w-1/12'}>Hòa</div>
            <div className={'w-1/12'}>Bại</div>
            <div className={'w-1/12'}>Ghi</div>
            <div className={'w-1/12'}>Mất</div>
            <div className={'w-1/12'}>Điểm</div>
            <div className={'w-2/12'}>Xếp hạng</div>
            <div className={'w-1/12 text-right'}>T%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>Tổng</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[0]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.totalStandings[0]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.totalStandings[0]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.totalStandings[0]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>Sân Nhà</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[0]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[0]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[0]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[0]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[0]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[0]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.homeHalfStandings[0]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.homeHalfStandings[0]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.homeHalfStandings[0]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left font-extra-bold'}>Sân Khách</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[0]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[0]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[0]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[0]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[0]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[0]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.awayHalfStandings[0]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.awayHalfStandings[0]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.awayHalfStandings[1]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>6 Trận Gần</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.halfStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.halfStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.halfStandings[1]?.winRate}%</div>
          </div>
        </div>

      </div>
      <div>
        <div className={'grid gap-1'}>
          <div
            className={'bg-gradient-start  text-button-blue-bet text-sm text-center p-0.5 rounded-sm'}>{away.name}</div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center bg-header-blue p-[7px] text-button-blue-bet text-xxxs dark:bg-pure-black dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>FT</div>
            <div className={'w-1/12'}>Trận</div>
            <div className={'w-1/12'}>Thắng</div>
            <div className={'w-1/12'}>Hòa</div>
            <div className={'w-1/12'}>Bại</div>
            <div className={'w-1/12'}>Ghi</div>
            <div className={'w-1/12'}>Mất</div>
            <div className={'w-1/12'}>Điểm</div>
            <div className={'w-2/12'}>Xếp hạng</div>
            <div className={'w-1/12 text-right'}>T%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>Tổng</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.totalStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.totalStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.totalStandings[1]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>Sân Nhà</div>
            <div className={'w-1/12'}>{standing?.homeStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.homeStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.homeStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.homeStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.homeStandings[1]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left font-extra-bold'}>Sân Khách</div>
            <div className={'w-1/12'}>{standing?.awayStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.awayStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.awayStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.awayStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.awayStandings[1]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>6 Trận Gần</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.halfStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.halfStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.halfStandings[1]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center bg-header-blue p-[7px] text-button-blue-bet text-xxxs dark:bg-pure-black dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>HT</div>
            <div className={'w-1/12'}>Trận</div>
            <div className={'w-1/12'}>Thắng</div>
            <div className={'w-1/12'}>Hòa</div>
            <div className={'w-1/12'}>Bại</div>
            <div className={'w-1/12'}>Ghi</div>
            <div className={'w-1/12'}>Mất</div>
            <div className={'w-1/12'}>Điểm</div>
            <div className={'w-2/12'}>Xếp hạng</div>
            <div className={'w-1/12 text-right'}>T%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>Tổng</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.totalStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.totalStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.totalStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.totalStandings[1]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>Sân Nhà</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.homeHalfStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.homeHalfStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.homeHalfStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.homeHalfStandings[1]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left font-extra-bold'}>Sân Khách</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.awayHalfStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.awayHalfStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.awayHalfStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.awayHalfStandings[1]?.winRate}%</div>
          </div>
          <div
            className={'flex flex-row justify-between pl-[29px] items-center text-center p-[7px] text-button-blue-bet text-xxxs bg-white dark:bg-dark-slate dark:text-stroke-o3'}>
            <div className={'w-2/12 text-left'}>6 Trận Gần</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.totalCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.winCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.drawCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.loseCount}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.getScore}</div>
            <div className={'w-1/12'}>{standing?.halfStandings[1]?.loseScore}</div>
            <div className={'w-1/12 font-extra-bold'}>{standing?.halfStandings[1]?.integral}</div>
            <div className={'w-2/12 font-extra-bold'}>{standing?.halfStandings[1]?.rank}</div>
            <div className={'w-1/12 text-right'}>{standing?.halfStandings[1]?.winRate}%</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(DetailRankingTable)